var React = require('react');

function ExpandMoreDarkTheme (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd"},React.createElement("path",{"d":"M16 21.6L30.3 7.3l1.4 1.4L16 24.4.3 8.7l1.4-1.4"})));
}

ExpandMoreDarkTheme.defaultProps = {"fill":"#fff","fillOpacity":"0.9","width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = ExpandMoreDarkTheme;

ExpandMoreDarkTheme.default = ExpandMoreDarkTheme;
